/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */

import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Cookies from 'js-cookie';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import NumberFormat from 'react-number-format';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import usePayPalAvailability from '../../../hooks/usePayPalAvailability';
import api from '../../../api/api';
import PayPalButtons from '../../../components/PayPalButtons/PayPalButtons';
import PayPalErrorBoundary from '../../../components/PayPalErrorBoundary/PayPalErrorBoundary';
import ApplePayButton from '../../../components/ApplePayButton/ApplePayButton';
import GooglePayButton from '../../../components/GooglePayButton/GooglePayButton';
import NmiApplePayButton from '../../../components/NmiApplePayButton/NmiApplePayButton';
import NmiGooglePayButton from '../../../components/NmiGooglePayButton/NmiGooglePayButton';
import CrossSells from '../../../components/CrossSells/CrossSells';
import ColorSelect from '../../../components/ColorSelect/ColorSelect';
import VariantSelect from '../../../components/VariantSelect/VariantSelect';

import {
  buildQueryParams,
  getPriceWithCurrency,
  getSavingsPercent,
  makePlural
} from '../../../utils/helpers';
import { states } from '../../../utils/states';

import nanotuneLogo from './img/Nanotune_Logo.png';
import verifiedVisaSvg from './img/verified-visa.png';
import mastercardSecureSvg from './img/mastercard-secure.png';
import pciDssSvg from './img/pci-dss.png';
import secureSslSvg from './img/secure-ssl.png';
import moneyBackSvg from './img/money-back.svg';

import carousel1 from './img/carousel/Carosel_1-242bc92d-6c90-465a-844e-9ce6d52c7ca3.webp';
import carousel2 from './img/carousel/Carosel_2-764fab5e-5448-4c33-ae10-a02d8188d717.webp';
import carousel3 from './img/carousel/Carosel_3-371a0643-ae19-4c09-966f-e0f9199f09dd.webp';
import carousel4 from './img/carousel/Carosel_4-efa96602-2a00-46bd-ba32-842d61cecf2a.webp';
import carousel5 from './img/carousel/Carosel_5-64575953-2e11-42a7-87a4-9089312a871f.webp';
import carousel6 from './img/carousel/Carosel_6-5406ffa2-69b0-4de9-820f-c7a7a987c4c4.webp';
import carousel7 from './img/carousel/Carosel_7-5ec727fd-6c86-45fc-b33c-1f89adc7edc0.webp';
import carousel8 from './img/carousel/Carosel_8-5d6304af-61b0-4adf-8460-848bdc877633.webp';
import carousel9 from './img/carousel/Carosel_9-3a2c9e2f-9cc4-4d9f-9447-1de0be37ea21.webp';
import carousel10 from './img/carousel/Carosel_10-4b2fc866-a064-41f4-b160-c12982b25ada.webp';
import carousel11 from './img/carousel/Carosel_11-4e23da17-2b00-489c-be4b-e977648ed84d.webp';
import carousel12 from './img/carousel/Carosel_12-5846a844-1fad-4863-a9bc-a080107e7be8.webp';
import carousel13 from './img/carousel/Carosel_13-4c76a53b-49e4-4fc3-bd1e-1131ee64ba55.webp';
import carousel14 from './img/carousel/Carosel_14-bc844ea6-efbb-481c-8e87-5fb789665792.webp';

import customerAvatar1 from './img/avatars/avatar-1.png';
import customerAvatar2 from './img/avatars/avatar-2.png';
import customerAvatar3 from './img/avatars/avatar-3.png';

import visa from '../Default/img/visa.webp';
import master from '../Default/img/master.webp';
import amex from '../Default/img/amex.webp';

import styles from './CommerceCore.module.css';

const heroSlotImages = [
  carousel1,
  carousel2,
  carousel3,
  carousel4,
  carousel5,
  carousel6,
  carousel7,
  carousel8,
  carousel9,
  carousel10,
  carousel11,
  carousel12,
  carousel13,
  carousel14
];

const customerAvatarImages = [customerAvatar1, customerAvatar2, customerAvatar3];

function getFbcValue(queryParams) {
  if (Cookies.get('_fbc')) return Cookies.get('_fbc');
  if (queryParams.fbclid) {
    return `fb.1.${new Date().getTime()}.${queryParams.fbclid}`;
  }
  return '';
}

const validationMessages = {
  email: 'Enter valid email address.',
  phone: 'Enter valid phone number.',
  creditCardNumber: 'Enter valid credit card number.',
  firstName: 'First name is required.',
  lastName: 'Last name is required.',
  shippingAddress1: 'Shipping address is required.',
  shippingCity: 'City is required.',
  shippingState: 'This Field is required.',
  shippingZip: 'ZIP code is required.',
  expirationMonth: 'Select a valid expiration month.',
  expirationYear: 'Select a valid expiration year.',
  CVV: 'Enter valid CVV.',
  isTermsAgreed: 'You must agree to the terms.'
};

function validateField(fieldName, value, shippingCountry) {
  switch (fieldName) {
    case 'email': {
      const emailFormatRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!value || !emailFormatRegex.test(value)) return validationMessages.email;
      const domainPart = value.substring(value.lastIndexOf('@') + 1);
      if (domainPart.includes('..')) return validationMessages.email;
      break;
    }
    case 'phone':
      if (!value) return validationMessages.phone;
      if (shippingCountry === 'GB') {
        if (!/^\+44\d{10}$/.test(value.replace(/\s+/g, ''))) return 'Enter a valid UK phone number.';
      } else if (shippingCountry === 'US') {
        if (!/^\+1\d{10}$/.test(value.replace(/\s+/g, ''))) return 'Enter a valid US phone number.';
      }
      break;
    case 'creditCardNumber':
      if (!value || !/^\d{13,19}$/.test(value.replace(/\s+/g, '')))
        return validationMessages.creditCardNumber;
      break;
    case 'firstName':
      if (!value) return validationMessages.firstName;
      break;
    case 'lastName':
      if (!value) return validationMessages.lastName;
      break;
    case 'shippingAddress1':
      if (!value) return validationMessages.shippingAddress1;
      break;
    case 'shippingCity':
      if (!value) return validationMessages.shippingCity;
      break;
    case 'shippingState':
      if (!value) return validationMessages.shippingState;
      break;
    case 'shippingZip':
      if (!value) return validationMessages.shippingZip;
      if (shippingCountry === 'US') {
        if (!/^[0-9]+$/.test(value)) return 'US ZIP code must contain only numbers.';
        if (value.length !== 5) return 'US ZIP code must be 5 digits.';
      }
      break;
    case 'expirationMonth':
      if (!value || isNaN(value) || value < 1 || value > 12) return validationMessages.expirationMonth;
      break;
    case 'expirationYear':
      if (!value || isNaN(value)) return validationMessages.expirationYear;
      break;
    case 'CVV':
      if (!value || !/^\d{3,4}$/.test(value)) return validationMessages.CVV;
      break;
    case 'isTermsAgreed':
      if (!value) return validationMessages.isTermsAgreed;
      break;
    default:
      break;
  }
  return null;
}

const validateForm = (data, shippingCountry) => {
  const errors = {};
  Object.keys(validationMessages).forEach((field) => {
    const error = validateField(field, data[field], shippingCountry);
    if (error) errors[field] = error;
  });
  if (!errors.expirationMonth && !errors.expirationYear) {
    const expDate = moment(`${data.expirationMonth}-${data.expirationYear}`, 'MM-YYYY', true).endOf('month');
    if (!expDate.isValid() || expDate.isBefore(moment(), 'day')) {
      errors.expirationMonth = validationMessages.expirationMonth;
      errors.expirationYear = validationMessages.expirationYear;
    }
  }
  return errors;
};

// Inline SVG icons
function StarIcon({ filled = true }) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 0.5L10.163 5.3L15.5 5.97L11.575 9.52L12.587 14.5L8 11.885L3.413 14.5L4.425 9.52L0.5 5.97L5.837 5.3L8 0.5Z'
        fill={filled ? '#FFC438' : '#e0e0e0'}
      />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='10' cy='10' r='10' fill='#0D40FF' />
      <path
        d='M5.75 10.25L8.5 13L14.25 7.25'
        stroke='#fff'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 5.333h-.667V4A3.333 3.333 0 008 .667 3.333 3.333 0 004.667 4v1.333H4c-.733 0-1.333.6-1.333 1.334v6.666c0 .734.6 1.334 1.333 1.334h8c.733 0 1.333-.6 1.333-1.334V6.667c0-.734-.6-1.334-1.333-1.334zM8 11.333A1.333 1.333 0 118 8.667a1.333 1.333 0 010 2.666zM10 5.333H6V4a2 2 0 114 0v1.333z'
        fill='#fff'
      />
    </svg>
  );
}

function ChevronDown() {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4 6L8 10L12 6' stroke='#333' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

function GalleryPrev() {
  return (
    <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.06 2.22a.75.75 0 0 1-.02 1.06L5.78 7.5l4.26 4.22a.75.75 0 1 1-1.06 1.06l-4.78-4.74a.75.75 0 0 1 0-1.08l4.78-4.74a.75.75 0 0 1 1.06-.02z'
        fill='#333'
      />
    </svg>
  );
}

function GalleryNext() {
  return (
    <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.94 2.22a.75.75 0 0 0 .02 1.06L10.22 7.5 5.96 11.72a.75.75 0 1 0 1.06 1.06l4.78-4.74a.75.75 0 0 0 0-1.08L7.02 2.22a.75.75 0 0 0-1.06-.02z'
        fill='#333'
      />
    </svg>
  );
}

function DiscountIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10 2.5L12.163 6.8L17 7.42L13.375 10.67L14.325 15.5L10 13.04L5.675 15.5L6.625 10.67L3 7.42L7.837 6.8L10 2.5Z'
        fill='#3362ab'
      />
    </svg>
  );
}

function TagIcon() {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        d='M7.45 1.17H2.33a1.17 1.17 0 0 0-1.16 1.16V7.45c0 .31.12.6.34.83l5.25 5.25a1.17 1.17 0 0 0 1.65 0l5.12-5.12a1.17 1.17 0 0 0 0-1.65L8.28 1.51a1.17 1.17 0 0 0-.83-.34Z'
        stroke='#5c5c5c'
        strokeWidth='1.1'
        strokeLinejoin='round'
      />
      <circle cx='4.67' cy='4.67' r='0.93' fill='#5c5c5c' />
    </svg>
  );
}

function PriceStack({ value, locale, currency }) {
  const formatted = getPriceWithCurrency(value, locale, currency);
  if (!formatted) return null;
  const match = formatted.match(/^([^\d-]*)(-?[\d,]+)(?:[.,](\d+))?(.*)$/);
  if (!match) {
    return (
      <div className={styles.packageNewPrice}>
        <span className={styles.priceWhole}>{formatted}</span>
      </div>
    );
  }
  const [, currencySymbol, whole, cents, trailing] = match;
  return (
    <div className={styles.packageNewPrice}>
      {currencySymbol && <span className={styles.priceCurrency}>{currencySymbol.trim()}</span>}
      <span className={styles.priceWhole}>{whole}</span>
      <div className={styles.priceTail}>
        {cents && <span className={styles.priceCents}>.{cents}</span>}
        {trailing && trailing.trim() && <span className={styles.priceCurrency}>{trailing.trim()}</span>}
        <span className={styles.priceEach}>each</span>
      </div>
    </div>
  );
}

function shortenProductName(name) {
  if (!name) return '';
  return name.trim();
}

function ClockIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='10' cy='10' r='8' stroke='#333' strokeWidth='1.5' fill='none' />
      <path d='M10 5V10L13 12' stroke='#333' strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
}

function StockBoxIcon() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        d='M2.5 6.5L10 2.5l7.5 4v7L10 17.5l-7.5-4v-7z'
        stroke='#ff2d2b'
        strokeWidth='1.5'
        strokeLinejoin='round'
        fill='none'
      />
      <path
        d='M2.5 6.5L10 10.5l7.5-4M10 10.5v7'
        stroke='#ff2d2b'
        strokeWidth='1.5'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
}

function getStockBarColor(percent) {
  if (percent > 60) return '#3bd16f';
  if (percent > 30) return '#ffb020';
  return '#ff2d2b';
}

// Custom White Checkmark for checkbox
function WhiteCheck() {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2 5L4 7L8 3' stroke='#fff' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}

function USFlagIcon() {
  return (
    <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' width='16' height='16' aria-hidden='true'>
      <rect width='16' height='16' rx='2' fill='#b22234' />
      <rect y='2' width='16' height='1.5' fill='#fff' />
      <rect y='5' width='16' height='1.5' fill='#fff' />
      <rect y='8' width='16' height='1.5' fill='#fff' />
      <rect y='11' width='16' height='1.5' fill='#fff' />
      <rect y='14' width='16' height='1.5' fill='#fff' />
      <rect width='7' height='7' fill='#3c3b6e' />
    </svg>
  );
}

function UKFlagIcon() {
  return (
    <svg
      viewBox='0 0 60 30'
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      aria-hidden='true'
      preserveAspectRatio='none'
    >
      <clipPath id='ukflag-cc-s'>
        <path d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z' />
      </clipPath>
      <path d='M0,0 v30 h60 v-30 z' fill='#012169' />
      <path d='M0,0 L60,30 M60,0 L0,30' stroke='#fff' strokeWidth='6' />
      <path d='M0,0 L60,30 M60,0 L0,30' clipPath='url(#ukflag-cc-s)' stroke='#C8102E' strokeWidth='4' />
      <path d='M30,0 v30 M0,15 h60' stroke='#fff' strokeWidth='10' />
      <path d='M30,0 v30 M0,15 h60' stroke='#C8102E' strokeWidth='6' />
    </svg>
  );
}

function GalleryPrevArrow(props) {
  const { onClick, className } = props;
  const isDisabled = !!(className && className.includes('slick-disabled'));
  return (
    <button
      type='button'
      className={`${styles.galleryNav} ${styles.galleryNavPrev}`}
      onClick={onClick}
      disabled={isDisabled}
      aria-label='Previous image'
    >
      <GalleryPrev />
    </button>
  );
}

function GalleryNextArrow(props) {
  const { onClick, className } = props;
  const isDisabled = !!(className && className.includes('slick-disabled'));
  return (
    <button
      type='button'
      className={`${styles.galleryNav} ${styles.galleryNavNext}`}
      onClick={onClick}
      disabled={isDisabled}
      aria-label='Next image'
    >
      <GalleryNext />
    </button>
  );
}

export default function CommerceCore({
  offer,
  isLoading,
  crossSells,
  onTermsClick,
  onCreateOrder,
  declineError,
  reviews,
  showReviews,
  isCooldownActive
}) {
  const queryParams = buildQueryParams(location);
  const showPayPal = queryParams.paypal !== '0' && (queryParams.paypal === '1' || offer.showPayPal);
  const showApplePay = queryParams.applepay !== '0' && (queryParams.applepay === '1' || offer.showApplePay);
  const showGooglePay =
    queryParams.googlepay !== '0' && (queryParams.googlepay === '1' || offer.showGooglePay);
  const isVariantSelectorTest = queryParams.variantselectortest === '1';

  const mergedProductsData = offer.productsData.map((product) => {
    const productDetail = offer.productDetails[product.id];
    return { ...product, ...productDetail };
  });

  const defaultProduct = mergedProductsData.find(
    (item) => String(item?.id) === String(offer?.defaultVariantId)
  );
  const preSelectedProduct = mergedProductsData.find(
    (item) => String(item?.id) === String(queryParams?.productid)
  );
  const initialProduct = preSelectedProduct || defaultProduct || mergedProductsData[0];
  const defaultVariantId = offer.defaultVariantId;
  const someProductIsSubscription = mergedProductsData.some((item) => item.billingModelId !== '2');
  const initialOfferType = initialProduct?.billingModelId === '2' ? 'one-time' : 'subscription';

  const [clientToken, setClientToken] = useState(null);
  const { isPayPalEnabled, isLoading: isPayPalLoading } = usePayPalAvailability(clientToken);

  const [selectedProduct, setSelectedProduct] = useState(initialProduct);
  const [selectedVariant, setSelectedVariant] = useState({
    name: initialProduct?.color || initialProduct?.variantValue,
    imageSrc: initialProduct?.colorImage || initialProduct?.colorimage || initialProduct?.variantImage
  });
  const [selectedOfferType, setSelectedOfferType] = useState(initialOfferType);
  const [isSizeGuideOpen, setIsSizeGuideOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [galleryNav1, setGalleryNav1] = useState(null);
  const [galleryNav2, setGalleryNav2] = useState(null);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [stockCount] = useState(Math.floor(Math.random() * 50) + 40);

  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 10, seconds: 0 });

  const isSelectedProductSubscription = selectedProduct?.billingModelId !== '2';

  const [state, setState] = useState({
    email: '',
    firstName: '',
    lastName: '',
    shippingAddress1: '',
    shippingCity: '',
    shippingState: 'AL',
    shippingCountry: offer?.shippingCountries[0]?.id || 'US',
    shippingZip: '',
    phone: '',
    creditCardNumber: '',
    expirationMonth: '',
    expirationYear: '',
    CVV: '',
    billingFirstName: '',
    billingLastName: '',
    billingAddress1: '',
    billingCity: '',
    billingState: '',
    billingCountry: 'US',
    billingZip: '',
    billingSameAsShipping: true,
    brand: offer.brand,
    isTermsAgreed: true,
    productId: initialProduct.id,
    productQty: initialProduct.quantity,
    productName: initialProduct.name,
    productPrice: initialProduct.price,
    agreeSms: false,
    fbc: getFbcValue(queryParams),
    fbp: Cookies.get('_fbp'),
    fbclid: queryParams.fbclid || '',
    orderTotal: initialProduct.price * 1 + initialProduct.shippingPrice * 1,
    campaignId: offer.campaignId,
    shippingId: initialProduct.shippingId || '',
    shippingPrice: initialProduct.shippingPrice || '',
    offers: [
      {
        product_id: initialProduct.id,
        offer_id: initialProduct.offerId,
        billing_model_id: initialProduct.billingModelId,
        price: initialProduct.price,
        productQty: initialProduct.quantity,
        productName: initialProduct.name,
        isMainProduct: true,
        ...(initialProduct?.trial?.enabled && {
          trial: {
            ...(initialProduct.trial.productId && { product_id: initialProduct.trial.productId }),
            ...(initialProduct.trial.price && { price: initialProduct.trial.price }),
            ...(initialProduct.trial.quantity && { quantity: initialProduct.trial.quantity })
          }
        })
      }
    ]
  });

  // ===== Effects (identical to Default) =====

  useEffect(() => {
    const currentDefaultProduct =
      mergedProductsData.find((item) => String(item.id) === String(queryParams.productid)) ||
      mergedProductsData.find((item) => String(item.id) === String(defaultVariantId)) ||
      mergedProductsData[0];
    if (!selectedProduct || String(selectedProduct.id) !== String(currentDefaultProduct.id)) {
      const productToSelect = currentDefaultProduct;
      setSelectedProduct(productToSelect);
      setSelectedVariant({
        name: productToSelect?.color || productToSelect?.variantValue,
        imageSrc: productToSelect?.colorImage || productToSelect?.colorimage || productToSelect?.variantImage
      });
      setSelectedOfferType(productToSelect?.billingModelId === '2' ? 'one-time' : 'subscription');
    }
  }, [offer.productsData]);

  useEffect(() => {
    if (!selectedProduct || !selectedVariant?.name) return;
    const filteredProducts = filterProducts(mergedProductsData);
    let newSelectedProduct = filteredProducts.find(
      (item) =>
        item.quantity === selectedProduct?.quantity &&
        (item.color || item.variantValue) === selectedVariant?.name &&
        (someProductIsSubscription
          ? item.billingModelId ===
            (selectedOfferType === 'subscription' ? selectedProduct?.billingModelId : '2')
          : true)
    );
    if (!newSelectedProduct && filteredProducts.length > 0) newSelectedProduct = filteredProducts[0];
    if (
      newSelectedProduct &&
      newSelectedProduct?.id !== selectedProduct?.id &&
      newSelectedProduct.soldOut !== '1'
    ) {
      setSelectedProduct(newSelectedProduct);
    } else if (newSelectedProduct?.soldOut === '1') {
      setSelectedProduct(null);
    }
  }, [selectedOfferType, selectedVariant]);

  useEffect(() => {
    if (!selectedProduct) return;
    const correspondingProduct = mergedProductsData.find(
      (item) =>
        item.quantity === selectedProduct?.quantity &&
        (item.color || item.variantValue) === selectedVariant?.name &&
        item.id !== selectedProduct?.id &&
        (selectedOfferType === 'subscription' ? item.billingModelId !== '2' : item.billingModelId === '2')
    );
    if (correspondingProduct && correspondingProduct.id !== selectedProduct.id) {
      setSelectedProduct(correspondingProduct);
    }
  }, [selectedOfferType]);

  useEffect(() => {
    const stickyOffer = {
      billing_model_id: selectedProduct?.billingModelId,
      offer_id: selectedProduct?.offerId,
      product_id: selectedProduct?.id,
      price: selectedProduct?.price,
      productQty: selectedProduct?.quantity,
      productName: selectedProduct?.name,
      isMainProduct: true,
      ...(selectedProduct?.trial?.enabled && {
        trial: {
          ...(selectedProduct.trial.productId && { product_id: selectedProduct.trial.productId }),
          ...(selectedProduct.trial.price && { price: selectedProduct.trial.price }),
          ...(selectedProduct.trial.quantity && { quantity: selectedProduct.trial.quantity })
        }
      })
    };
    const currentOffers = state.offers || [];
    const newOffers = currentOffers.filter((o) => !o.isMainProduct);
    newOffers.push(stickyOffer);
    const offersTotal = newOffers.reduce((total, o) => total + o.price * 1, 0);
    const orderTotal = offersTotal + selectedProduct?.shippingPrice * 1;
    setState({
      ...state,
      orderTotal,
      offers: newOffers,
      shippingId: selectedProduct?.shippingId,
      shippingPrice: selectedProduct?.shippingPrice,
      productId: selectedProduct?.id,
      productQty: selectedProduct?.quantity,
      productName: selectedProduct?.name,
      productPrice: selectedProduct?.price
    });
  }, [selectedProduct]);

  useEffect(() => {
    if (crossSells.length > 0) {
      const preSelectedFromOffer = crossSells.filter((item) =>
        item.preselectedOffers.some((o) => o.id === offer._id)
      );
      const urlCrossSellIds = queryParams.crosssellid
        ? queryParams.crosssellid.split(',').map((id) => id.trim())
        : [];
      const preSelectedFromUrl = crossSells.filter((item) => urlCrossSellIds.includes(String(item._id)));
      const preSelectedIds = new Set(preSelectedFromOffer.map((item) => item._id));
      const combinedPreSelected = [
        ...preSelectedFromOffer,
        ...preSelectedFromUrl.filter((item) => !preSelectedIds.has(item._id))
      ];
      if (combinedPreSelected.length > 0) {
        const crossSellOffers = [];
        combinedPreSelected.forEach((item) => {
          let itemToAdd = item;
          if (item.variants && item.variants.length > 0) itemToAdd = item.variants[0];
          crossSellOffers.push({
            billing_model_id: itemToAdd.productBillingModelId,
            offer_id: itemToAdd.productOfferId,
            product_id: itemToAdd.productId,
            price: itemToAdd.price,
            productName: itemToAdd.productName || itemToAdd.name,
            productQty: '1',
            isCrossSell: true,
            ...(item.trial?.enabled && {
              trial: {
                product_id: item.trial.productId,
                price: item.trial.price,
                quantity: item.trial.quantity
              }
            })
          });
        });
        setState((prevState) => {
          const currentOffers = prevState.offers || [];
          const offersWithoutPreselectedCrossSells = currentOffers.filter(
            (o) => !(o.isCrossSell && o.preselected)
          );
          const newOffers = [...offersWithoutPreselectedCrossSells, ...crossSellOffers];
          const offersTotal = newOffers.reduce((total, o) => total + o.price * 1, 0);
          const orderTotal = offersTotal + selectedProduct?.shippingPrice * 1;
          return { ...prevState, orderTotal, offers: newOffers };
        });
      }
    }
  }, [crossSells]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((prev) => {
        let { hours, minutes, seconds } = prev;
        if (seconds > 0) seconds -= 1;
        else if (minutes > 0) {
          seconds = 59;
          minutes -= 1;
        } else if (hours > 0) {
          seconds = 59;
          minutes = 59;
          hours -= 1;
        } else clearInterval(intervalId);
        return { hours, minutes, seconds };
      });
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const merchantAccountId = offer.braintreeMerchantAccountId || offer.payPalMerchantAccountId;
    const needsToken = (showPayPal || showApplePay || showGooglePay) && merchantAccountId;
    if (!needsToken) return;
    (async () => {
      try {
        const { data } = await api.get(`/braintree/token?merchantAccountId=${merchantAccountId}`);
        setClientToken(data.clientToken);
      } catch (error) {
        console.error('Failed to fetch Braintree token:', error);
      }
    })();
  }, [
    offer.braintreeMerchantAccountId,
    offer.payPalMerchantAccountId,
    showPayPal,
    showApplePay,
    showGooglePay
  ]);

  useEffect(() => {
    if (state.shippingCountry === 'US' || state.shippingCountry === 'CA') {
      setState({ ...state, shippingState: 'AL' });
    } else {
      setState({ ...state, shippingState: '' });
    }
  }, [state.shippingCountry]);

  // ===== Helpers =====

  function updateOffers(item, meta) {
    const newOffers = [...state.offers];
    const existingItem = state.offers.find((o) => o.product_id * 1 === item.productId * 1);
    if (existingItem) {
      newOffers.splice(newOffers.indexOf(existingItem), 1);
    } else {
      newOffers.push({
        billing_model_id: item.productBillingModelId,
        offer_id: item.productOfferId,
        product_id: item.productId,
        price: item.price,
        productName: item.productName || item.name,
        ...(item.trial?.enabled && {
          trial: { product_id: item.trial.productId, price: item.trial.price, quantity: item.trial.quantity }
        }),
        ...meta
      });
    }
    setState({ ...state, offers: newOffers });
  }

  function filterProductsByVariant(items) {
    if (!selectedVariant) return items;
    const variantName = selectedVariant.name || selectedVariant.variantValue;
    return items.filter((item) => (item.color || item.variantValue) === variantName);
  }

  function filterByOfferType(items) {
    if (someProductIsSubscription) {
      return items.filter((item) => {
        if (selectedOfferType === 'subscription') return item.billingModelId !== '2';
        return item.billingModelId === '2';
      });
    }
    return items;
  }

  function filterProducts(items) {
    return filterByOfferType(filterProductsByVariant(items));
  }

  function getSavings() {
    const qty = selectedProduct?.quantity;
    if (!qty) return 0;
    const oneTimeProduct = mergedProductsData.find(
      (item) => item.billingModelId === '2' && item.quantity === qty
    );
    const subscriptionProduct = mergedProductsData.find(
      (item) => item.billingModelId !== '2' && item.quantity === qty
    );
    return getPriceWithCurrency(
      oneTimeProduct?.price * 1 + oneTimeProduct?.shippingPrice * 1 - subscriptionProduct?.price * 1,
      offer?.locale,
      offer?.currency
    );
  }

  // ===== Handlers =====

  function handleVariantSelect(variant) {
    setSelectedVariant(variant);
    const newProduct = mergedProductsData.find(
      (item) =>
        (item.color || item.variantValue) === variant.name && item.quantity === selectedProduct?.quantity
    );
    if (newProduct?.soldOut === '1') setSelectedProduct(null);
    setSelectedProduct(newProduct);
  }

  function handleFieldBlur(fieldName) {
    const errorMessage = validateField(fieldName, state[fieldName], state.shippingCountry);
    setErrors((prev) => ({ ...prev, [fieldName]: errorMessage }));
  }

  function handleCrossSellChange(crossSell) {
    updateOffers(crossSell, { isCrossSell: true });
  }

  function handleExpressApprove(data) {
    handleCreateOrder(data);
  }

  function handleFormSubmit() {
    if (isCooldownActive) return;
    const validationErrors = validateForm(state, state.shippingCountry);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      handleCreateOrder(state);
    } else {
      const firstErrorField = Object.keys(validationErrors)[0];
      const fieldElement = document.querySelector(`[name="${firstErrorField}"]`);
      if (fieldElement) fieldElement.focus();
    }
  }

  function handleCreateOrder(data) {
    const stickyOffer = {
      billing_model_id: selectedProduct?.billingModelId,
      offer_id: selectedProduct?.offerId,
      product_id: selectedProduct?.id,
      price: selectedProduct?.price,
      productQty: selectedProduct?.quantity,
      productName: selectedProduct?.name,
      isMainProduct: true,
      ...(selectedProduct?.trial?.enabled && {
        trial: {
          ...(selectedProduct.trial.productId && { product_id: selectedProduct.trial.productId }),
          ...(selectedProduct.trial.price && { price: selectedProduct.trial.price }),
          ...(selectedProduct.trial.quantity && { quantity: selectedProduct.trial.quantity })
        }
      })
    };
    const currentOffers = state.offers || [];
    const newOffers = currentOffers.filter((o) => !o.isMainProduct);
    newOffers.push(stickyOffer);
    const offersTotal = newOffers.reduce((total, o) => total + o.price * 1, 0);
    const orderTotal = offersTotal + selectedProduct?.shippingPrice * 1;
    const expirationDate = `${state.expirationMonth}${state.expirationYear.slice(-2)}`;
    const orderData = {
      ...data,
      expirationDate,
      orderTotal,
      offers: newOffers,
      shippingId: selectedProduct?.shippingId,
      shippingPrice: selectedProduct?.shippingPrice,
      productId: selectedProduct?.id,
      productQty: selectedProduct?.quantity,
      productName: selectedProduct?.name,
      productPrice: selectedProduct?.price
    };
    if (!selectedProduct) {
      setErrors({ ...errors, product: 'Please select a product' });
      return;
    } else {
      setErrors({ ...errors, product: null });
    }
    onCreateOrder(orderData);
  }

  // ===== Gallery =====
  // Hero gallery is intentionally independent of the selected product/package.
  // Replace the PNG files in ./img/hero/slot-N.png to swap in real imagery.
  const galleryImages = offer.heroImages && offer.heroImages.length > 0 ? offer.heroImages : heroSlotImages;
  const hasMultipleImages = galleryImages.length > 1;

  const mainSliderSettings = {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    fade: false,
    asNavFor: galleryNav2,
    prevArrow: <GalleryPrevArrow />,
    nextArrow: <GalleryNextArrow />
  };

  const thumbsSliderSettings = {
    asNavFor: galleryNav1,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    infinite: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 5,
          slidesToScroll: 1,
          focusOnSelect: true,
          arrows: false,
          infinite: false
        }
      }
    ]
  };

  // ===== Render Helpers =====
  const variantTitle = mergedProductsData.find((p) => p.variantName)?.variantName;
  const discountPercent = getSavingsPercent(selectedProduct?.oldPrice, selectedProduct?.price);
  const timerStr = `${String(timeLeft.minutes).padStart(2, '0')}:${String(timeLeft.seconds).padStart(2, '0')}`;

  // Testimonials from offer or hardcoded fallback (matches reference 7-review set)
  const testimonials = offer.testimonials || [
    {
      author: 'Noah M.',
      title: 'Best Decision Ever',
      stars: 5,
      body: 'I&#8217;ve been using NanoTune for a few weeks now, and the results are unbelievable. I actually thought I&#8217;d have to return it before my results came in. I realized it&#8217;s as simple as pouring it in. Definitely ordering 3 more for all of my cars!'
    },
    {
      author: 'Adam P.',
      title: 'NanoTune Exceeds Expectations',
      stars: 5,
      body: 'Just ordered my NanoTune 2 days ago, and I&#8217;m already happy with the success. I tested it immediately and after these few days, I assure it&#8217;s unlike anything else I&#8217;ve tried before. My gas tank is still half even though it used to be empty after this time. I can&#8217;t imagine why this additive is not more popular, not to mention people positively contributing to the planet.'
    },
    {
      author: 'Fenty S.',
      title: 'Immediate Savings',
      stars: 5,
      body: 'I read a lot about fuel saving products, but NanoTune stood out to me among the alternatives. It&#8217;s so easy to use. After pouring it into my engine, I started to see significant improvement in fuel efficiency within a short period. NanoTune&#8217;s innovative formula optimizes engine performance \u2014 a must have for those wishing to cut down on fuel costs without compromising their driving experience.'
    },
    {
      author: 'Olivia M.',
      title: 'Incredible Product',
      stars: 5,
      body: 'NanoTune helped me save not only fuel but also money! I was skeptical at first, but my fuel consumption dropped significantly \u2014 I can finally save up some money for a new car, all because of NanoTune.'
    },
    {
      author: 'Oliver C.',
      title: 'Happy with the Purchase',
      stars: 5,
      body: 'Can&#8217;t believe I only heard about it a few weeks ago. I&#8217;m very environmentally conscious, so I&#8217;ve been looking for a product like this for a long time. It should be in every car. It&#8217;s very affordable and will pay for itself in just seven days. Not to mention how much you&#8217;ll help the planet!'
    },
    {
      author: 'Mason J.',
      title: 'Best Product',
      stars: 5,
      body: 'I&#8217;m a salesman and I have to travel to different cities every morning. My company doesn&#8217;t cover all fuel costs, so this additive saved me so much time, money, and fuel \u2014 no longer have to fill up the tank twice per day. I&#8217;ve gotten so much faster at the end of the day. Truly recommended for anyone who has to drive for a living.'
    },
    {
      author: 'Liam G.',
      title: 'Surprisingly Useful!',
      stars: 5,
      body: 'Honestly didn&#8217;t believe this additive would work, but it just so happened that I got it as a present. Now I&#8217;m the one buying it for all my family members! It&#8217;s compatible with many cars since it&#8217;s easy to use \u2014 all you need to do is twist and pour it into your engine oil. I&#8217;m actually excited to see how much I can save next time. 10/10'
    }
  ];

  const flagText = offer.flagText || 'AMERICA\u2019S #1 RATED FUEL-SAVING SOLUTION';

  const heroDescription =
    offer.productDescription ||
    'Forget Buying Fuel Every Few Days and Choose NanoTune To Save Money and Time';

  const heroBenefits =
    offer.benefits && offer.benefits.length > 0
      ? offer.benefits
      : [
          'Saves up to half a tank of fuel',
          'Reduces your carbon footprint',
          'Simple twist-and-pour application',
          'Compatible with all gas and diesel vehicles'
        ];

  // Benefits
  const benefitsData = offer.benefitsSection || [
    {
      icon: '💰',
      title: '30-Day Money Back Guarantee',
      text: "If our product doesn't meet your expectations, you can return it within 30 days for a full refund."
    },
    {
      icon: '⭐',
      title: 'Over 75,000+ Happy Customers',
      text: "Everyone who tries our product agrees – it's a smart investment with proven results."
    },
    {
      icon: '🎧',
      title: 'Professional Customer Support',
      text: "Our customer service is available 24/7 for your satisfaction. Don't hesitate to contact us anytime."
    }
  ];

  function renderOrderSummary() {
    return (
      <div className={styles.orderSummary}>
        <button className={styles.orderSummaryToggle} onClick={() => setSummaryOpen(!summaryOpen)}>
          <span>Order Summary</span>
          <span className={`${styles.orderSummaryArrow} ${summaryOpen ? styles.orderSummaryArrowOpen : ''}`}>
            <ChevronDown />
          </span>
        </button>
        <div className={`${styles.orderSummaryContent} ${summaryOpen ? styles.orderSummaryContentOpen : ''}`}>
          <div className={styles.orderSummaryInner}>
            <div className={styles.summaryRow}>
              <span>
                {selectedProduct?.quantity}x{' '}
                {makePlural(offer.productName, selectedProduct?.quantity * 1, offer.productNameSingular)}
              </span>
              <span>{getPriceWithCurrency(selectedProduct?.price, offer?.locale, offer?.currency)}</span>
            </div>
            {(state.offers || [])
              .filter((o) => o.isCrossSell)
              .map((o, i) => {
                const matchingCrossSell = crossSells.find((cs) => {
                  if (String(cs.productId) === String(o.product_id)) return true;
                  return (cs.variants || []).some((v) => String(v.productId) === String(o.product_id));
                });
                const displayName =
                  matchingCrossSell?.title || matchingCrossSell?.name || o.productName || 'Add-on';
                return (
                  <div key={`cs-${o.product_id}-${i}`} className={styles.summaryRow}>
                    <span>
                      {o.productQty ? `${o.productQty}x ` : ''}
                      {displayName}
                    </span>
                    <span>{getPriceWithCurrency(o.price, offer?.locale, offer?.currency)}</span>
                  </div>
                );
              })}
            <div className={styles.summaryRow}>
              <span>Shipping</span>
              <span>
                {selectedProduct?.shippingPrice > 0
                  ? getPriceWithCurrency(selectedProduct?.shippingPrice, offer?.locale, offer?.currency)
                  : 'FREE'}
              </span>
            </div>
            {selectedProduct?.oldPrice && (
              <div className={styles.savingsStrip}>
                <span className={styles.savingsText}>
                  Total savings:{' '}
                  {getPriceWithCurrency(
                    selectedProduct?.oldPrice * 1 - selectedProduct?.price * 1,
                    offer?.locale,
                    offer?.currency
                  )}
                </span>
              </div>
            )}
            <div className={`${styles.summaryRow} ${styles.summaryRowTotal}`}>
              <span>Total</span>
              <span>{getPriceWithCurrency(state.orderTotal, offer?.locale, offer?.currency)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderStateSelect() {
    if (state.shippingCountry === 'US' || state.shippingCountry === 'CA') {
      return (
        <div className={styles.selectContainer}>
          <select
            name='shippingState'
            value={state.shippingState}
            onChange={(e) => {
              setState({ ...state, shippingState: e.target.value });
              setErrors((prev) => ({ ...prev, shippingState: null }));
            }}
            onBlur={() => handleFieldBlur('shippingState')}
            className={`${styles.selectInput} ${errors.shippingState ? styles.inputError : ''}`}
          >
            {Object.entries(states[state.shippingCountry]).map(([code, name], index) => (
              <option key={index} value={code}>
                {name}
              </option>
            ))}
          </select>
          <span className={styles.selectLabel}>State/Province</span>
          {errors.shippingState && <div className={styles.errorMessage}>{errors.shippingState}</div>}
        </div>
      );
    }
    return (
      <div className={styles.inputContainer}>
        <input
          type='text'
          name='shippingState'
          value={state.shippingState}
          className={`${styles.input} ${state.shippingState ? styles.inputFilled : ''} ${errors.shippingState ? styles.inputError : ''}`}
          onChange={(e) => {
            setState({ ...state, shippingState: e.target.value });
            setErrors((prev) => ({ ...prev, shippingState: null }));
          }}
          onBlur={() => handleFieldBlur('shippingState')}
          placeholder='County/District/Region'
        />
        <label className={styles.inputLabel}>County/District/Region</label>
        {errors.shippingState && <div className={styles.errorMessage}>{errors.shippingState}</div>}
      </div>
    );
  }

  // ===== RENDER =====
  return (
    <div className={styles.page}>
      {/* TOP BAR */}
      <div className={styles.topBar}>SPECIAL LIMITED TIME OFFER - UP TO {discountPercent}% OFF!</div>

      {/* HEADER */}
      <div className={styles.headerWrapper}>
        <div className={styles.header}>
          <img src={nanotuneLogo} alt='NanoTune' className={styles.headerLogo} />
        </div>
      </div>

      {/* HERO */}
      <div className={styles.heroWrapper}>
        <div className={styles.heroContainer}>
          {/* Gallery (left) */}
          <div className={styles.galleryWrapper}>
            <div className={styles.galleryContainer}>
              {hasMultipleImages && (
                <div className={styles.galleryThumbnails}>
                  <Slider {...thumbsSliderSettings} ref={setGalleryNav2}>
                    {galleryImages.map((img, i) => (
                      <div key={i} className={styles.galleryThumbWrap}>
                        <div className={styles.galleryThumb}>
                          <img src={img} alt={`${offer.productName} ${i + 1}`} />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              )}
              <div className={styles.galleryMain}>
                {hasMultipleImages ? (
                  <Slider {...mainSliderSettings} ref={setGalleryNav1}>
                    {galleryImages.map((img, i) => (
                      <div key={i} className={styles.galleryMainSlide}>
                        <img src={img} alt={`${offer.productName} ${i + 1}`} />
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <img
                    src={galleryImages[0] || selectedProduct?.image || offer.logoSrc}
                    alt={offer.productName}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Hero Info (right) */}
          <div className={styles.heroInfo}>
            {/* Special Offer Flag */}
            {flagText && (
              <div className={styles.heroFlag}>
                <span className={styles.heroFlagIcon} aria-hidden='true'>
                  <USFlagIcon />
                </span>
                <span>{flagText}</span>
              </div>
            )}

            {/* Rating */}
            <div className={styles.heroRatingLine}>
              <div className={styles.heroStars}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <StarIcon key={n} filled={n <= 4} />
                ))}
              </div>
              <span className={styles.heroRating}>4.9</span>
              <span className={styles.heroRatingDivider} />
              <span className={styles.heroRatingText}>1000+ Verified Reviews</span>
            </div>

            {/* Title */}
            <h1 className={styles.heroHeading}>Cut Your Fuel Consumption with NanoTune</h1>

            {/* Description */}
            <p className={styles.heroDescription}>{heroDescription}</p>

            {/* Benefits checklist */}
            <div className={styles.heroBenefits}>
              {heroBenefits.map((benefit, i) => (
                <div key={i} className={styles.heroBenefitItem}>
                  <CheckIcon />
                  <span dangerouslySetInnerHTML={{ __html: benefit }} />
                </div>
              ))}
            </div>

            {/* Social Media Banner */}
            <div className={styles.socialBanner}>
              <div className={styles.socialAvatars}>
                {customerAvatarImages.map((src, i) => (
                  <img key={i} src={src} alt='' aria-hidden='true' className={styles.socialAvatar} />
                ))}
                <span className={styles.socialAvatarsCheck} aria-hidden='true'>
                  <svg
                    width='10'
                    height='10'
                    viewBox='0 0 10 10'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M2 5L4 7L8 3'
                      stroke='#fff'
                      strokeWidth='1.5'
                      strokeLinecap='round'
                      strokeLinejoin='round'
                    />
                  </svg>
                </span>
              </div>
              <span className={styles.socialText}>
                <strong>80K+</strong> Happy Customers
              </span>
              <span className={styles.socialDivider} aria-hidden='true' />
              <span className={styles.socialText}>
                <strong>4.9</strong> Average Rating
              </span>
            </div>

            {/* Selling Points */}
            {offer.benefitsWithIcons && offer.benefitsWithIcons.length > 0 && (
              <div className={styles.sellingPoints}>
                {offer.benefitsWithIcons.map((sp, i) => (
                  <div key={i} className={styles.sellingPointItem}>
                    <img src={sp.icon} alt={sp.name} />
                    <span>{sp.name}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* BOTTOM LINE */}
      <div className={styles.bottomLine} />

      {/* MAIN CONTENT */}
      <div className={styles.mainWrapper}>
        <div className={styles.mainLeftBg} />
        <div className={styles.contentContainer}>
          {/* Order Summary (mobile-only, rendered above the product column) */}
          <div className={styles.orderSummaryMobile}>{renderOrderSummary()}</div>

          {/* LEFT COLUMN - Bars + Packages + Express + Payment + Form + Submit */}
          <div className={styles.productColumn}>
            {/* Urgency Bars */}
            <div className={styles.barsContainer}>
              <div className={`${styles.bar} ${styles.barStock}`}>
                <span className={styles.barStockLeft}>
                  <StockBoxIcon />
                  Only <span className={styles.barStockAccent}>{stockCount} items</span>
                </span>
                <div className={styles.barStockRight}>
                  <div className={styles.stockBarTrack}>
                    <div
                      className={styles.stockBarFill}
                      style={{
                        width: `${Math.min(stockCount, 100)}%`,
                        background: getStockBarColor(Math.min(stockCount, 100))
                      }}
                    />
                  </div>
                </div>
                <span className={styles.barStockRightLabel}>Left in Stock!</span>
              </div>
              <div className={`${styles.bar} ${styles.barDiscount}`}>
                <DiscountIcon />
                <span>
                  Your <strong>{discountPercent}% Discount</strong> Has Been Applied
                </span>
              </div>
              <div className={`${styles.bar} ${styles.barTimer}`}>
                <ClockIcon />
                <span>
                  Hurry! Your discount is reserved for <span className={styles.barTimerBold}>{timerStr}</span>{' '}
                  minutes!
                </span>
              </div>
            </div>

            {/* Package Picker */}
            <div className={styles.packagesSection}>
              <div className={styles.packagesHeading}>
                {preSelectedProduct ? 'Selected Product' : 'Choose Your Package'}
              </div>

              {someProductIsSubscription && !preSelectedProduct && (
                <div className={styles.offerSelector}>
                  <button
                    className={`${styles.offerSelectorBtn} ${selectedOfferType === 'one-time' ? styles.offerSelectorBtnActive : ''}`}
                    onClick={() => setSelectedOfferType('one-time')}
                  >
                    One-Time Purchase
                  </button>
                  <button
                    className={`${styles.offerSelectorBtn} ${selectedOfferType === 'subscription' ? styles.offerSelectorBtnActive : ''}`}
                    onClick={() => setSelectedOfferType('subscription')}
                  >
                    Subscribe &amp; Save
                    <span className={styles.offerSelectorSave}>extra {getSavings()}</span>
                    <span className={styles.offerSelectorFree}>+FREE SHIPPING ALWAYS</span>
                  </button>
                </div>
              )}

              <div className={styles.packagesGrid}>
                {filterProducts(mergedProductsData).map((product) => {
                  const isActive = selectedProduct?.id === product.id;
                  const isSoldOut = product.soldOut === '1';
                  const savingsPercent = product.oldPrice
                    ? getSavingsPercent(product.oldPrice, product.price)
                    : null;
                  return (
                    <div
                      key={product.id}
                      className={`${styles.packageCard} ${isActive ? styles.packageCardActive : ''} ${isSoldOut ? styles.packageSoldOut : ''}`}
                      onClick={() => !isSoldOut && setSelectedProduct(product)}
                    >
                      <div className={`${styles.packageRadio} ${isActive ? styles.packageRadioActive : ''}`}>
                        <div className={styles.packageRadioInner} />
                      </div>
                      {product.image && (
                        <img src={product.image} alt={offer.productName} className={styles.packageImage} />
                      )}
                      <div className={styles.packageInfo}>
                        <span className={styles.packageQty}>{product.quantity}x</span>
                        <span
                          className={styles.packageName}
                          dangerouslySetInnerHTML={{
                            __html: shortenProductName(
                              makePlural(offer.productName, product.quantity * 1, offer.productNameSingular)
                            )
                          }}
                        />
                        {product.subtitle && <span className={styles.packageEach}>{product.subtitle}</span>}
                        {savingsPercent ? (
                          <div className={`${styles.packageSaveChip} ${styles.packageSaveChipInline}`}>
                            <TagIcon />
                            <span>{savingsPercent}%</span>
                          </div>
                        ) : (
                          <div
                            className={`${styles.packageSaveChipInline} ${styles.packageSaveChipInlinePlaceholder}`}
                            aria-hidden='true'
                          />
                        )}
                      </div>
                      <div
                        className={`${styles.packageDivider} ${styles.packageDividerInfo}`}
                        aria-hidden='true'
                      />
                      <div className={styles.packageSaveColumn}>
                        {savingsPercent ? (
                          <div className={`${styles.packageSaveChip} ${styles.packageSaveChipColumn}`}>
                            <TagIcon />
                            <span>{savingsPercent}%</span>
                          </div>
                        ) : (
                          <div className={styles.packageSaveChipPlaceholder} aria-hidden='true' />
                        )}
                      </div>
                      <div className={styles.packageDivider} aria-hidden='true' />
                      <div className={styles.packagePrice}>
                        {product.oldPrice && (
                          <span className={styles.packageOldPrice}>
                            {getPriceWithCurrency(product.oldPrice, offer?.locale, offer?.currency)}
                          </span>
                        )}
                        <PriceStack value={product.price} locale={offer?.locale} currency={offer?.currency} />
                        {product.mostPopular && (
                          <span className={`${styles.packageBadge} ${styles.badgeBestSeller}`}>
                            Best Seller
                          </span>
                        )}
                        {product.bestValue && (
                          <span className={`${styles.packageBadge} ${styles.badgeBestValue}`}>
                            Best Value
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              {selectedVariant && selectedVariant.name && !isVariantSelectorTest && (
                <ColorSelect
                  title={variantTitle ? `Choose Your ${variantTitle}` : 'Choose Your Option'}
                  products={mergedProductsData}
                  onChange={handleVariantSelect}
                  selectedVariant={selectedVariant}
                  defaultVariantId={defaultVariantId}
                />
              )}
              {selectedVariant && selectedVariant.name && isVariantSelectorTest && (
                <VariantSelect
                  title={variantTitle ? `Choose Your ${variantTitle}` : 'Choose Your Option'}
                  products={mergedProductsData}
                  onChange={handleVariantSelect}
                  selectedVariant={selectedVariant}
                  defaultVariantId={defaultVariantId}
                  sizeGuide={
                    offer.sizeGuideImage && (
                      <div className={styles.sizeGuideContainer}>
                        <button onClick={() => setIsSizeGuideOpen(true)}>Size guide</button>
                      </div>
                    )
                  }
                />
              )}
              {!isVariantSelectorTest && offer.sizeGuideImage && (
                <div className={styles.sizeGuideContainer}>
                  <button onClick={() => setIsSizeGuideOpen(true)}>Size guide</button>
                </div>
              )}
            </div>

            {/* Cross-sells */}
            {crossSells.length > 0 && (
              <div className={styles.crossSellsSection}>
                <CrossSells
                  offer={offer}
                  offers={state.offers}
                  crossSells={crossSells}
                  onChange={handleCrossSellChange}
                />
              </div>
            )}

            <div className={styles.mobileSeparator} />

            {/* Express Checkout */}
            {clientToken &&
              clientToken.startsWith('eyJ') &&
              (showPayPal || showApplePay || showGooglePay) && (
                <>
                  <div className={styles.expressSection}>
                    <div className={styles.expressLabel}>Express checkout</div>
                    <div className={styles.expressButtons}>
                      {showPayPal && !isPayPalLoading && isPayPalEnabled && (
                        <PayPalErrorBoundary>
                          <PayPalScriptProvider
                            options={{
                              vault: true,
                              clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
                              components: 'buttons',
                              dataClientToken: clientToken
                            }}
                          >
                            <PayPalButtons
                              offer={offer}
                              orderData={state}
                              checkoutTotal={state.orderTotal}
                              onApprove={handleExpressApprove}
                              isSelectedProductSubscription={isSelectedProductSubscription}
                            />
                          </PayPalScriptProvider>
                        </PayPalErrorBoundary>
                      )}
                      {showApplePay &&
                        (offer.paymentGateway === 'nmi' ? (
                          <NmiApplePayButton
                            checkoutTotal={state.orderTotal}
                            orderData={state}
                            offer={offer}
                            onApprove={handleExpressApprove}
                          />
                        ) : (
                          <ApplePayButton
                            clientToken={clientToken}
                            checkoutTotal={state.orderTotal}
                            orderData={state}
                            offer={offer}
                            onApprove={handleExpressApprove}
                          />
                        ))}
                      {showGooglePay &&
                        (offer.paymentGateway === 'nmi' ? (
                          <NmiGooglePayButton
                            checkoutTotal={state.orderTotal}
                            orderData={state}
                            offer={offer}
                            onApprove={handleExpressApprove}
                          />
                        ) : (
                          <GooglePayButton
                            clientToken={clientToken}
                            checkoutTotal={state.orderTotal}
                            orderData={state}
                            offer={offer}
                            onApprove={handleExpressApprove}
                          />
                        ))}
                    </div>
                  </div>
                  <div className={styles.expressSeparator}>
                    <span className={styles.expressSeparatorText}>Or continue to pay with credit card</span>
                  </div>
                </>
              )}

            {/* Payment Methods */}
            <div className={styles.formSection}>
              <div className={styles.sectionHeading}>Payment Methods</div>
              <p
                style={{
                  color: '#828282',
                  fontSize: 12,
                  lineHeight: '16px',
                  marginTop: -8,
                  marginBottom: 16
                }}
              >
                All transactions are secure encrypted.
              </p>

              <div className={styles.accordionGroup}>
                <div className={styles.accordionItem}>
                  <button
                    className={`${styles.accordionHeader} ${paymentMethod === 'card' ? styles.accordionHeaderActive : ''}`}
                    onClick={() => setPaymentMethod('card')}
                  >
                    <div
                      className={`${styles.accordionRadio} ${paymentMethod === 'card' ? styles.accordionRadioActive : ''}`}
                    >
                      <div className={styles.accordionRadioInner} />
                    </div>
                    <span>Credit Card</span>
                    <div className={styles.accordionHeaderCards}>
                      <img src={visa} alt='Visa' />
                      <img src={master} alt='Mastercard' />
                      {offer.currency !== 'GBP' && <img src={amex} alt='Amex' />}
                    </div>
                  </button>
                  <div
                    className={`${styles.accordionContent} ${paymentMethod === 'card' ? styles.accordionContentOpen : ''}`}
                  >
                    <div className={styles.accordionContentInner}>
                      <div className={styles.inputContainer}>
                        <NumberFormat
                          name='creditCardNumber'
                          format='#### #### #### ####'
                          placeholder='Card Number'
                          value={state.creditCardNumber}
                          className={`${styles.input} ${state.creditCardNumber ? styles.inputFilled : ''} ${errors.creditCardNumber ? styles.inputError : ''}`}
                          onValueChange={(values) => {
                            setState({ ...state, creditCardNumber: values.value });
                            setErrors((prev) => ({ ...prev, creditCardNumber: null }));
                          }}
                          onBlur={() => handleFieldBlur('creditCardNumber')}
                        />
                        <label className={styles.inputLabel}>Card Number</label>
                        {errors.creditCardNumber && (
                          <div className={styles.errorMessage}>{errors.creditCardNumber}</div>
                        )}
                      </div>
                      <div className={styles.inputRow}>
                        <div className={styles.selectContainer}>
                          <select
                            name='expirationMonth'
                            value={state.expirationMonth}
                            onChange={(e) => {
                              setState({ ...state, expirationMonth: e.target.value });
                              setErrors((prev) => ({ ...prev, expirationMonth: null }));
                            }}
                            onBlur={() => handleFieldBlur('expirationMonth')}
                            className={`${styles.selectInput} ${errors.expirationMonth ? styles.inputError : ''}`}
                          >
                            <option value=''>Month</option>
                            {Array.from({ length: 12 }, (_, i) => {
                              const m = String(i + 1).padStart(2, '0');
                              return (
                                <option key={m} value={m}>
                                  {m}
                                </option>
                              );
                            })}
                          </select>
                          <span className={styles.selectLabel}>Expiry Month</span>
                          {errors.expirationMonth && (
                            <div className={styles.errorMessage}>{errors.expirationMonth}</div>
                          )}
                        </div>
                        <div className={styles.selectContainer}>
                          <select
                            name='expirationYear'
                            value={state.expirationYear}
                            onChange={(e) => {
                              setState({ ...state, expirationYear: e.target.value });
                              setErrors((prev) => ({ ...prev, expirationYear: null }));
                            }}
                            onBlur={() => handleFieldBlur('expirationYear')}
                            className={`${styles.selectInput} ${errors.expirationYear ? styles.inputError : ''}`}
                          >
                            <option value=''>Year</option>
                            {Array.from({ length: 20 }, (_, i) => {
                              const year = new Date().getFullYear() + i;
                              return (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              );
                            })}
                          </select>
                          <span className={styles.selectLabel}>Expiry Year</span>
                          {errors.expirationYear && (
                            <div className={styles.errorMessage}>{errors.expirationYear}</div>
                          )}
                        </div>
                      </div>
                      <div className={styles.inputContainer}>
                        <NumberFormat
                          name='CVV'
                          format='####'
                          placeholder='CVV'
                          value={state.CVV}
                          className={`${styles.input} ${state.CVV ? styles.inputFilled : ''} ${errors.CVV ? styles.inputError : ''}`}
                          onValueChange={(values) => {
                            setState({ ...state, CVV: values.value });
                            setErrors((prev) => ({ ...prev, CVV: null }));
                          }}
                          onBlur={() => handleFieldBlur('CVV')}
                        />
                        <label className={styles.inputLabel}>CVV/CVC</label>
                        {errors.CVV && <div className={styles.errorMessage}>{errors.CVV}</div>}
                      </div>
                    </div>
                  </div>
                </div>
                {showPayPal && (
                  <div className={styles.accordionItem}>
                    <button
                      className={`${styles.accordionHeader} ${paymentMethod === 'paypal' ? styles.accordionHeaderActive : ''}`}
                      onClick={() => setPaymentMethod('paypal')}
                    >
                      <div
                        className={`${styles.accordionRadio} ${paymentMethod === 'paypal' ? styles.accordionRadioActive : ''}`}
                      >
                        <div className={styles.accordionRadioInner} />
                      </div>
                      <span>PayPal</span>
                    </button>
                    <div
                      className={`${styles.accordionContent} ${paymentMethod === 'paypal' ? styles.accordionContentOpen : ''}`}
                    >
                      <div className={styles.paypalInner}>
                        After clicking "Complete Order" button, you will be redirected to PayPal to complete
                        your transaction securely.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Customer Information */}
            <div className={styles.formSection}>
              <div className={styles.sectionHeading}>Customer Information</div>
              <div className={styles.inputContainer}>
                <input
                  type='email'
                  name='email'
                  value={state.email}
                  className={`${styles.input} ${state.email ? styles.inputFilled : ''} ${errors.email ? styles.inputError : ''}`}
                  onChange={(e) => {
                    setState({ ...state, email: e.target.value });
                    setErrors((p) => ({ ...p, email: null }));
                  }}
                  onBlur={() => handleFieldBlur('email')}
                  placeholder='Email Address'
                />
                <label className={styles.inputLabel}>Email Address</label>
                {errors.email && <div className={styles.errorMessage}>{errors.email}</div>}
              </div>
              <div className={styles.inputRow}>
                <div className={styles.inputContainer}>
                  <input
                    type='text'
                    name='firstName'
                    value={state.firstName}
                    className={`${styles.input} ${state.firstName ? styles.inputFilled : ''} ${errors.firstName ? styles.inputError : ''}`}
                    onChange={(e) => {
                      setState({ ...state, firstName: e.target.value });
                      setErrors((p) => ({ ...p, firstName: null }));
                    }}
                    onBlur={() => handleFieldBlur('firstName')}
                    placeholder='First Name'
                  />
                  <label className={styles.inputLabel}>First Name</label>
                  {errors.firstName && <div className={styles.errorMessage}>{errors.firstName}</div>}
                </div>
                <div className={styles.inputContainer}>
                  <input
                    type='text'
                    name='lastName'
                    value={state.lastName}
                    className={`${styles.input} ${state.lastName ? styles.inputFilled : ''} ${errors.lastName ? styles.inputError : ''}`}
                    onChange={(e) => {
                      setState({ ...state, lastName: e.target.value });
                      setErrors((p) => ({ ...p, lastName: null }));
                    }}
                    onBlur={() => handleFieldBlur('lastName')}
                    placeholder='Last Name'
                  />
                  <label className={styles.inputLabel}>Last Name</label>
                  {errors.lastName && <div className={styles.errorMessage}>{errors.lastName}</div>}
                </div>
              </div>
              <div className={styles.inputContainer}>
                <div className={styles.phoneInputWrapper}>
                  <span className={styles.phonePrefix}>
                    <span className={styles.phoneFlag}>
                      {state.shippingCountry === 'GB' ? <UKFlagIcon /> : <USFlagIcon />}
                    </span>
                    <span>
                      {state.shippingCountry === 'GB'
                        ? '+44'
                        : state.shippingCountry === 'US' || state.shippingCountry === 'CA'
                          ? '+1'
                          : ''}
                    </span>
                  </span>
                  <input
                    type='tel'
                    name='phone'
                    value={state.phone.replace(/^\+44|^\+1/, '')}
                    className={`${styles.input} ${state.phone ? styles.inputFilled : ''} ${errors.phone ? styles.inputError : ''}`}
                    onChange={(e) => {
                      const prefix =
                        state.shippingCountry === 'GB'
                          ? '+44'
                          : state.shippingCountry === 'US' || state.shippingCountry === 'CA'
                            ? '+1'
                            : '';
                      setState({ ...state, phone: `${prefix}${e.target.value.replace(/\D/g, '')}` });
                      setErrors((p) => ({ ...p, phone: null }));
                    }}
                    onBlur={() => handleFieldBlur('phone')}
                    placeholder='Phone Number'
                  />
                  <label
                    className={styles.inputLabel}
                    style={{ left: state.shippingCountry === 'GB' ? 86 : 76 }}
                  >
                    Phone Number
                  </label>
                </div>
                {errors.phone && <div className={styles.errorMessage}>{errors.phone}</div>}
              </div>
            </div>

            {/* Delivery Address */}
            <div className={styles.formSection}>
              <div className={styles.sectionHeading}>Delivery Address</div>
              <div className={styles.selectContainer}>
                <select
                  name='shippingCountry'
                  value={state.shippingCountry}
                  onChange={(e) => setState({ ...state, shippingCountry: e.target.value })}
                  className={styles.selectInput}
                >
                  {offer.shippingCountries.map((country) => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <span className={styles.selectLabel}>Country</span>
              </div>
              <div className={styles.inputContainer}>
                <input
                  type='text'
                  name='shippingAddress1'
                  value={state.shippingAddress1}
                  className={`${styles.input} ${state.shippingAddress1 ? styles.inputFilled : ''} ${errors.shippingAddress1 ? styles.inputError : ''}`}
                  onChange={(e) => {
                    setState({ ...state, shippingAddress1: e.target.value });
                    setErrors((p) => ({ ...p, shippingAddress1: null }));
                  }}
                  onBlur={() => handleFieldBlur('shippingAddress1')}
                  placeholder='Address'
                />
                <label className={styles.inputLabel}>Address</label>
                {errors.shippingAddress1 && (
                  <div className={styles.errorMessage}>{errors.shippingAddress1}</div>
                )}
              </div>
              <div className={styles.inputRow}>
                <div className={styles.inputContainer}>
                  <input
                    type='text'
                    name='shippingCity'
                    value={state.shippingCity}
                    className={`${styles.input} ${state.shippingCity ? styles.inputFilled : ''} ${errors.shippingCity ? styles.inputError : ''}`}
                    onChange={(e) => {
                      setState({ ...state, shippingCity: e.target.value });
                      setErrors((p) => ({ ...p, shippingCity: null }));
                    }}
                    onBlur={() => handleFieldBlur('shippingCity')}
                    placeholder='City'
                  />
                  <label className={styles.inputLabel}>City</label>
                  {errors.shippingCity && <div className={styles.errorMessage}>{errors.shippingCity}</div>}
                </div>
                {renderStateSelect()}
              </div>
              <div className={styles.inputContainer}>
                <input
                  type='text'
                  name='shippingZip'
                  value={state.shippingZip}
                  className={`${styles.input} ${state.shippingZip ? styles.inputFilled : ''} ${errors.shippingZip ? styles.inputError : ''}`}
                  onChange={(e) => {
                    setState({ ...state, shippingZip: e.target.value });
                    setErrors((p) => ({ ...p, shippingZip: null }));
                  }}
                  onBlur={() => handleFieldBlur('shippingZip')}
                  placeholder='Zip/Postcode'
                />
                <label className={styles.inputLabel}>Zip/Postcode</label>
                {errors.shippingZip && <div className={styles.errorMessage}>{errors.shippingZip}</div>}
              </div>
            </div>

            {/* Shipping Method */}
            <div className={styles.shippingMethod}>
              <span className={styles.shippingMethodLabel}>Standard Shipping (4-7 business days)</span>
              <span className={styles.shippingMethodValue}>
                {selectedProduct?.shippingPrice > 0
                  ? getPriceWithCurrency(selectedProduct?.shippingPrice, offer?.locale, offer?.currency)
                  : 'FREE'}
              </span>
            </div>

            {/* Newsletter checkbox */}
            <div className={styles.checkboxRow}>
              <input
                type='checkbox'
                id='agreeSms'
                checked={state.agreeSms}
                onChange={(e) => setState({ ...state, agreeSms: e.target.checked })}
                className={styles.checkboxInput}
              />
              <label htmlFor='agreeSms' className={styles.checkboxCheck}>
                <WhiteCheck />
              </label>
              <label htmlFor='agreeSms' className={styles.checkboxLabel}>
                Text me shipping updates and exclusive discounts
              </label>
            </div>
            {state.agreeSms && (
              <div className={styles.smsText}>
                By clicking this checkbox, you agree to receive marketing text messages from our company at
                the number provided. Consent is not a condition of purchase. Message and data rates may apply.
                Reply HELP for help or STOP to cancel.
              </div>
            )}

            {/* Terms */}
            <p className={styles.termsText}>
              By placing your order, you agree to{' '}
              <span onClick={() => onTermsClick()}>Terms and Conditions</span> of service.
            </p>

            {/* Encrypted text */}
            <div className={styles.encryptedText}>
              <span role='img' aria-label='lock'>
                🔒
              </span>{' '}
              All transactions are SSL secure and encrypted
            </div>

            {/* Submit */}
            <button
              onClick={() => handleFormSubmit()}
              className={styles.submitBtn}
              type='button'
              disabled={isLoading || isCooldownActive}
            >
              <span className={styles.submitBtnIcon}>
                <LockIcon />
              </span>
              <span className={styles.submitBtnText}>
                Complete Order {isLoading && <i className={`fas fa-spinner fa-spin ${styles.spinner}`}></i>}
              </span>
            </button>

            {isCooldownActive && (
              <div className={styles.declineError}>
                <p>
                  You've had multiple declined payment attempts. Please wait 15 minutes before trying again or
                  contact customer support.
                </p>
              </div>
            )}
            {declineError && !isCooldownActive && (
              <div className={styles.declineError}>
                <p>{declineError}</p>
              </div>
            )}
            {errors.product && <div className={styles.declineError}>{errors.product}</div>}

            {/* Payment Icons */}
            <div className={styles.paymentIcons}>
              <img src={secureSslSvg} alt='Secure SSL Encryption' />
              <img src={pciDssSvg} alt='PCI DSS Compliant' />
              <img src={mastercardSecureSvg} alt='MasterCard SecureCode' />
              <img src={verifiedVisaSvg} alt='Verified by Visa' />
            </div>
          </div>

          {/* RIGHT COLUMN - Money-back + Order Summary + Why Choose + Reviews */}
          <div className={styles.summaryColumn}>
            {/* Money-back badge */}
            <div className={styles.moneyBackBadge}>
              <img src={moneyBackSvg} alt='30-Day Money Back Guarantee' />
              <div>
                <div className={styles.moneyBackTitle}>30-Day Money Back Guarantee</div>
                <div className={styles.moneyBackText}>
                  Feel safe knowing you are protected with a 30 days guarantee. Simply contact our helpful
                  24/7 customer support for a swift &amp; easy refund or replacement.
                </div>
              </div>
            </div>

            {/* Order Summary Dropdown (desktop position) */}
            <div className={styles.orderSummaryDesktop}>{renderOrderSummary()}</div>

            {/* Why Choose section */}
            <div className={styles.benefitsSection}>
              <div className={styles.benefitsSectionTitle}>Why Choose {offer.productName || offer.brand}</div>
              <div className={styles.benefitsWrapper}>
                {benefitsData.map((b, i) => (
                  <div key={i} className={styles.benefitItem}>
                    <div className={styles.benefitItemIconWrap}>
                      {b.icon && typeof b.icon === 'string' && b.icon.startsWith('http') ? (
                        <img src={b.icon} alt={b.title} className={styles.benefitItemIcon} />
                      ) : (
                        <span className={styles.benefitItemIconEmoji}>{b.icon}</span>
                      )}
                    </div>
                    <div className={styles.benefitItemBody}>
                      <div className={styles.benefitItemTitle}>{b.title}</div>
                      <div className={styles.benefitItemText}>{b.text}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Testimonials / Reviews */}
            <div className={styles.testimonialsSection}>
              <div className={styles.testimonialsSectionTitle}>Over 3,000 5-Star Reviews</div>
              {testimonials.slice(0, 7).map((t, i) => (
                <div key={i} className={styles.testimonialCard}>
                  <div className={styles.testimonialHeader}>
                    <div className={styles.testimonialHeaderLeft}>
                      <div className={styles.testimonialStars}>
                        {[1, 2, 3, 4, 5].map((n) => (
                          <span key={n} className={styles.testimonialStar}>
                            <svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'>
                              <path
                                d='M8 0.5L10.163 5.3L15.5 5.97L11.575 9.52L12.587 14.5L8 11.885L3.413 14.5L4.425 9.52L0.5 5.97L5.837 5.3L8 0.5Z'
                                fill={n <= (t.stars || 5) ? '#fff' : 'rgba(255,255,255,0.4)'}
                              />
                            </svg>
                          </span>
                        ))}
                      </div>
                      <span className={styles.testimonialAuthor}>{t.author || t.name}</span>
                    </div>
                    <span className={styles.testimonialVerified}>Verified Buyer</span>
                  </div>
                  <div className={styles.testimonialTitle}>{t.title}</div>
                  <div
                    className={styles.testimonialBody}
                    dangerouslySetInnerHTML={{ __html: t.body || t.description || t.text }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.mainRightBg} />
      </div>

      {/* FOOTER */}
      <div className={styles.simpleFooter}>
        <div className={styles.footerLinks}>
          <button className={styles.footerLink} onClick={() => onTermsClick()}>
            Terms &amp; Conditions
          </button>
          <button className={styles.footerLink} onClick={() => onTermsClick()}>
            Privacy Policy
          </button>
          <button className={styles.footerLink} onClick={() => onTermsClick()}>
            Refund Policy
          </button>
          <button className={styles.footerLink} onClick={() => onTermsClick()}>
            Shipping Policy
          </button>
          <button className={styles.footerLink} onClick={() => onTermsClick()}>
            Contact us
          </button>
        </div>
      </div>

      {/* Size Guide Modal */}
      {isSizeGuideOpen && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <span className={styles.modalClose} onClick={() => setIsSizeGuideOpen(false)}>
              &times;
            </span>
            <img
              src={offer.sizeGuideImage}
              alt='Size Guide'
              style={{ maxWidth: '100%', maxHeight: '80vh' }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
